import { useCallback } from "react";
import { createViewServiceProviderCoAMappings } from "@/modules/lasalle/mappings/views/ViewServiceProviderCoAMappings";
import type {
    TSpCoaQuery,
    TCoAMappingView as TSpCoAMappingView,
} from "@/modules/lasalle/mappings/views/ViewServiceProviderCoAMappings";
import type { TCompositionDeps } from "@/ui/compositionRoot/types";

export const wireServiceProviderCoAMappings = ({ api }: TCompositionDeps) => {
    const ViewServiceProviderCoAMappings = createViewServiceProviderCoAMappings({
        useCases: () => ({
            onLoadServiceProvider: useCallback(
                async (serviceProviderId: string) => {
                    const sp = await api.serviceProviders.get(serviceProviderId);
                    return {
                        id: sp.id,
                        name: sp.name,
                        code: sp.code,
                    };
                },
                [api],
            ),
            onLoadCoAMappingsPage: useCallback(
                async (serviceProviderId: string, query: TSpCoaQuery, signal?: AbortSignal) => {
                    const response = await api.serviceProviders.listCoAMappings(
                        serviceProviderId,
                        {
                            ...query,
                            active_only: true,
                        },
                        signal,
                    );
                    const items: TSpCoAMappingView[] = response.items.map((m) => ({
                        id: m.id,
                        thirdAccountCode: m.third_account_code,
                        thirdAccountName: m.third_account_name,
                        yardiAccountId: m.yardi_account_id,
                        yardiAccountCode: m.yardi_account_code ?? null,
                        yardiAccountName: m.yardi_account_name ?? null,
                        isInForce: m.is_in_force,
                        isActive: m.is_active,
                        createdAt: m.created_at,
                        updatedAt: m.updated_at,
                    }));
                    return {
                        items,
                        total: response.total,
                        totalUnfiltered: response.total_unfiltered ?? response.total,
                    };
                },
                [api],
            ),
        }),
    });

    return { ViewServiceProviderCoAMappings };
};
